<!-- 校准订单成本价 -->
<template>
    <div v-loading="loading">
        <div class="searchAp-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="flex">
                        <div class="search-name">单号：{{ correctData.OrderCode }}</div>
                        <div class="search-name">客户名称：{{ correctData.EntpCusName }}</div>
                        <el-checkbox class="search-name" v-model="isFilterZero" size="small" label="过滤非0成本" @change="changeFilter"></el-checkbox>
                        <el-button class="search-btn btn-primary" size="small" @click="submitForm()">提交校准</el-button>
                        <el-checkbox v-model="isUpdateCost" size="small" label="同步更新商品成本价" border></el-checkbox>
                    </div>
                    <div class="sub-title">
                        <i class="el-icon-warning-outline"></i>
                        温馨提醒：同步更新商品成本价会改变当前商品的成本价，请谨慎操作！
                    </div>
                </div>
            </div>
            <div class="table-ctn corecttb">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%; margin-bottom: 10px">
                    <el-table-column prop="SortNum" label="序号" width="50"></el-table-column>
                    <el-table-column prop="APCode" label="汽配编码" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="GoodName" label="汽配名称" min-width="130" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="AutoSerise" label="车型" min-width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Origin" label="产地" min-width="80" show-overflow-tooltip></el-table-column>
                    <!-- <el-table-column prop="Count" label="数量" width="60" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.OrderType == 0 ? scope.row.Count : -scope.row.Count }}</template>
                    </el-table-column> -->
                    <el-table-column prop="CostPrice" label="单据成本价" width="95" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.CostPrice.toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column prop="GoodsCostPrice" label="商品成本价" width="95" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.GoodsCostPrice.toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column prop="CorrectCostPrice" label="校准成本价" width="95" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input-number style="width: 100%" size="small" v-model.trim="scope.row.CorrectCostPrice" :min="0" :precision="2" :controls="false"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['correctData'],
    data() {
        return {
            loading: false,
            tableData: [],
            isFilterZero: true,
            isUpdateCost: false,
            canSubmit: true,
            submitData: {
                OrderId: '',
                OrderType: 0,
                GoodsList: []
            }
        };
    },
    mounted() {
        if (this.correctData) {
            this.getTableData(this.correctData);
            this.submitData.OrderId = this.correctData.OrderId;
            this.OrderType = this.correctData.OrderType;
            this.submitData.OrderType = this.correctData.OrderType;
        }
    },
    methods: {
        getTableData(item) {
            this.loading = true;
            let url = '';
            if (item.OrderType == 0) url = '/api/EntpSaleOrder/GetOrderItemsByIdForCC';
            else url = '/api/EntpSaleReturnOrder/GetEntpCusReturnGoodsListByIdForCC';
            this.$util
                .axiosGet({
                    url: url,
                    data: {
                        OrderId: item.OrderId,
                        IsFilterZero: this.isFilterZero
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        this.tableData = res.data;
                        let isShowMsg = false;
                        this.tableData.forEach(item => {
                            if (item.CostPrice == 0) {
                                if (!item.GoodsCostPrice == 0) {
                                    isShowMsg = true;
                                    item.CorrectCostPrice = item.GoodsCostPrice;
                                } else item.CorrectCostPrice = 0;
                            } else {
                                item.CorrectCostPrice = item.CostPrice;
                            }
                        });
                        if (isShowMsg) {
                            this.$util.warningMsg('已经对成本价为0的数据进行赋值');
                        }
                    }
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        changeFilter() {
            this.getTableData(this.correctData);
        },
        closeDialog() {
            this.$emit('closeCorrectDialog');
        },
        submitForm() {
            let isHaveZero = false;
            let goodsList = [];
            this.tableData.forEach(item => {
                if (item.CorrectCostPrice == 0) {
                    isHaveZero = true;
                }
                let g = {
                    RId: item.RId,
                    GoodsId: item.GoodsId,
                    CorrectCostPrice: item.CorrectCostPrice
                };

                goodsList.push(g);
            });
            this.submitData.IsUpdateCost = this.isUpdateCost;
            this.submitData.GoodsList = goodsList;
            if (isHaveZero) {
                let title = '';
                title = '当前校准的成本价仍有等于0的数据，仍确定要提交吗？';

                this.$confirm(title, '提示', {
                    confirmButtonText: '确定继续提交',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.loading = true;
                        this.canSubmit = false;
                        this.$util
                            .axiosPost({
                                url: '/api/RevenueManagement_H/UpdateOrdersCostPrice',
                                data: this.submitData,
                                hideLoading: true
                            })
                            .then(res => {
                                this.$util.successMsg(res.errmsg);
                                this.$emit('closeCorrectDialog', res.data);
                            })
                            .catch(() => {
                                this.canSubmit = true;
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.canSubmit = false;
                this.$util
                    .axiosPost({
                        url: '/api/RevenueManagement_H/UpdateOrdersCostPrice',
                        data: this.submitData
                    })
                    .then(res => {
                        this.$util.successMsg(res.errmsg);
                        this.$emit('closeCorrectDialog', res.data);
                    })
                    .catch(() => {
                        this.canSubmit = true;
                    });
            }
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    overflow-y: auto;
}
.sub-title {
    color: red;
    margin-bottom: 5px;
}
</style>
<style lang="less">
.corecttb {
    .el-table__body {
        .el-table__row {
            td {
                padding: 0px 0 !important;
            }
        }
    }
}
</style>
